export const TEST_COMPANY_SCOPE_QUERY = {
  ALL: "all",
  TEST: "test",
  NON_TEST: "non_test",
} as const;

export type TestCompanyScope =
  (typeof TEST_COMPANY_SCOPE_QUERY)[keyof typeof TEST_COMPANY_SCOPE_QUERY];

export const testCompanyScopeDropdownValues = [
  { label: "All companies", value: TEST_COMPANY_SCOPE_QUERY.ALL },
  { label: "Test companies", value: TEST_COMPANY_SCOPE_QUERY.TEST },
  { label: "Non-test companies", value: TEST_COMPANY_SCOPE_QUERY.NON_TEST },
];

export const defaultTestCompanyScopeFilter = {
  testCompanyScope: TEST_COMPANY_SCOPE_QUERY.NON_TEST,
};
